const $cookieBanner = $('.js-cookie-banner');
const $cookieBannerClose = $('.js-cookie-banner-close');
const $ctaBanner = $('#js-cta-popup-banner');
const userHadConsentedToCookies = window.localStorage.getItem('cookie_consent') === 'true';

const canUseLocalStorage = () => {
  try {
    window.localStorage.setItem('test', 'test');
    window.localStorage.removeItem('test');
    return true;
  } catch (e) {
    return false;
  }
};

const showCookieBanner = () => {
  // Hide CTA banner if cookie banner is shown
  $ctaBanner.addClass('dn');

  // "show" the cookie banner, but 0 height 0 opacity
  $cookieBanner
    .css('maxHeight', '0px')
    .css('opacity', 0)
    .removeClass('dn');

  // animate to reveal banner
  setTimeout(() => {
    $cookieBanner
      .css('maxHeight', '150px')
      .css('opacity', 1);
  }, 100);
};

const closeCookieBanner = (e) => {
  e.preventDefault();
  window.localStorage.setItem('cookie_consent', 'true');

  // animate hiding the banner
  $cookieBanner
    .css('maxHeight', '0px')
    .css('opacity', 0);

  // actually hide the banner
  setTimeout(() => {
    $cookieBanner
      .css('maxHeight', '150px')
      .css('opacity', 1)
      .addClass('dn');
  }, 400);
};

$(() => {
  $cookieBannerClose.on('click', closeCookieBanner);
  if (canUseLocalStorage() === false) return;

  if (!userHadConsentedToCookies) {
    showCookieBanner();
  }
});
